import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { DISMISS_GET_APP_BANNER } from './types';

const dismissGetAppBannerAction = actionCreator(DISMISS_GET_APP_BANNER);

export const applicationDismissGetAppBannerAction = () => (dispatch) =>
  dispatch(dismissGetAppBannerAction());
